import type { ArchbaseRemoteApiClient } from '@archbase/data'
import { injectable, inject } from 'inversify'
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core'
import type { ResolvedSettingDto, SettingsListResponse } from '@domain/settings/SettingsDto'

@injectable()
export class DoclenzSettingsService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  /** Valor efetivo de cada parâmetro, com a origem e o estado de cadeado. */
  async findAll(): Promise<SettingsListResponse> {
    return this.client.get('/v1/admin/settings')
  }

  /**
   * Grava um valor no plano de plataforma. Vale na próxima requisição, sem restart.
   *
   * Respostas que a tela precisa distinguir: 409 quando o ambiente travou o parâmetro,
   * 400 quando o valor não passa na validação, 503 quando falta a chave de cifra e o
   * parâmetro é secreto.
   */
  async update(key: string, value: string): Promise<ResolvedSettingDto> {
    return this.client.put(`/v1/admin/settings/${encodeURIComponent(key)}`, { value })
  }

  /** Remove o override e devolve o parâmetro ao valor do ambiente. */
  async reset(key: string): Promise<ResolvedSettingDto> {
    return this.client.delete(`/v1/admin/settings/${encodeURIComponent(key)}`)
  }
}
